import axios from "axios";
import { env } from "@config";

const client = axios.create({
  baseURL: env.apiUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export default client;
